/**
 * Huella de los datos de un tenant que el formulario de edición muestra y permite cambiar.
 *
 * La ficha se refresca sola mientras la suscripción espera un pago. Esos refrescos cambian
 * `subscription` (y los contadores), que no se editan en el formulario: si el formulario se
 * volviera a rellenar con cada cambio, se perdería lo que el usuario ha escrito sin guardar.
 * Se vuelve a rellenar solo cuando cambia esta huella (otro tenant, o datos editables guardados).
 */
export function tenantFormSyncKey(tenant: object | null | undefined): string | null {
  if (!tenant) return null;
  const { subscription: _subscription, counts: _counts, ...editable } = tenant as Record<string, unknown>;
  return JSON.stringify(editable);
}
